
import { BIModel } from './BIModel';

export class UserViewingLikesBIModel extends BIModel {

  static eventName = 'user_viewing_likes';

  #productId;
  #isOwner;

  constructor(userId, productId, isOwner) {
    super(UserViewingLikesBIModel.eventName, userId);
    this.#productId = productId;
    this.#isOwner = isOwner;
  }

  get productId() {
    return this.#productId;
  }

  get isOwner() {
    return this.#isOwner;
  }

  get modelData() {
    return {
      product_id: this.productId,
      is_owner: this.isOwner
    }
  }
}
